import { useState } from "react";
import MailLogo from '../assets/img/email_logo.png';
import { useLanguage } from "../context/LanguageContext";


export default function MailIcon() {

    const { t } = useLanguage();

    const [copied, setCopied] = useState(false);
    const email = "trujillogonzalezfranciscojose@gmail.com";

    const copyEmail = () => {
        const input = document.createElement('input');
        input.value = email;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        document.body.removeChild(input);

        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };


    return (
        <div className="icon-wrapper" onClick={copyEmail}>
            <img src={MailLogo} alt="gmail" className="mail-icon" />
            {copied && <span className="tooltip">{t.home.copied}</span>}
        </div>
    );
}